var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sku)?_c('div',{staticClass:"flex"},[_vm._v(" "+_vm._s(_vm.qty)+" x "+_vm._s(_vm.sku)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }